// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"YZ-z","subtitle":"ZZ-z","wrapper":"_Z-z","leftArrow":"a0-z","rightArrow":"b0-z"};